import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FallbackTitleStyled = styled.h2`
  margin: 0 0 3rem;
  font-size: 4.6rem;
`;

export const GeneratedContentFallbackStyled = styled.div`
  border-radius: 10px;
  margin: 0 auto;
  max-width: 80%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 15rem;
  color: ${colors.neutral[900]};
`;

export const ContentSectionStyled = styled.div`
  width: 42%;
  max-width: 70rem;

  @media (width < 1024px) {
    width: 80%;
    margin: 0 auto;
  }
`;

export const TextSectionStyled = styled.div`
  padding-right: 1rem;

  @media (width < 1024px) {
    padding: 0;
  }
`;

export const FallbackMessageStyled = styled.p`
  font-size: 2.8rem;
  margin: 0 0 2rem;
`;

export const FallbackExplanation = styled.p`
  font-size: 1.8rem;
  margin: 0;
`;

export const FallbackImageStyled = styled.img`
  border-radius: 20cap;

  @media (width < 1024px) {
    display: none;
  }
`;

export const ActionBlock = styled.div`
  display: flex;
  margin-top: 5rem;
  gap: 3rem;

  @media (width < 491px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ActionButton = styled(Button)`
  min-width: 15rem;
  width: 40%;

  @media (width < 491px) {
    width: 100%;
  }
`;
